module.exports = __webpack_public_path__ + "img/MEDIA006.c5b025af.jpg";